module.exports = __webpack_public_path__ + "img/bankorder.e3427964.png";